import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { cloneDeep, forEach, get, isEmpty, isEqual, isNil, filter } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import uuid from 'uuid/v1';
import turf from '@turf/turf';

import * as mapOps from '../../../api/Maps/map-operations';
import * as layerOps from '../../../api/Layers/layer-operations';

import {
  featurePoint2LatLng,
  featureGetZoom,
  latlong2featurePoint,
  featureSetZoom,
  featureSetBBox
} from '../../../modules/geojson-utilities';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import ButtonOnMap from '../ButtonOnMap';
import LeafletMap from '../../components/LeafletMap';
import ExportProviderMap from '../../components/ExportProviderMap';

import * as annotationOps from '../../../api/Annotations/annotation-operations';

import * as videoOps from '../../../api/Videos/video-operations';
import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';

import useTimeStore from '../../components/ZustandProvider';

const { defaultMapCenter } = Meteor.settings.public;
let addDrawEventListenersMaps;
let arrayToSendCoordinates;
let circle;
let createGeometryDrawControlsMaps;
let customHomeButton;
let drawCustomButtons;
let drawMapInterestArea;
let drawMapLayers;
let drawVideoAnnotations;
let drawVideoTrack;
let estado = false;
let getBBoxFromCoordsAndZoom;
let getMapCenter;
let initializeLoaded = true;
let intervaloFunction;
let intervaloGoToFunction;
let L;
let localforage;
let marker;
let markerAnnotationCLick;
let markerAnnotationsProyected;
let markerCoordVideoPoint;
let markerAnnotationImaps;
let markerDownload;
let MiniMap;
const markerRoute = [];
let manyMarkerAnnotationsClick;
const manyAnnotationClick = [];
let markersPolygonDownload = [];
const oldLayers = [];
const oldMap = [];
const routes = [];
let sendCoordinates;
let showGeometryEditControls;
const timeCoordinates = 60;

class MapContainerViewMap extends Component {
  baseMapsToDisplay = null;

  layersToDisplay = null;

  aiInterestAreaDrawControl = null;

  aiInterestAreaEditControl = null;

  aiInterestAreaLayer = null;

  mapMap = null;

  annotationsLayer = null;

  trackVideoLayer = null;

  mapMapComponent = React.createRef();

  randomMapId = uuid();

  state = {
    aiInterestArea: {},
    coordsAnnotationClick: {},
    clientModulesReady: false,
    isLeafletMapLoaded: get(this, 'mapMapComponent.current.state.isMapLoaded', false),
    isMapMapLoaded: false,
    currentLocationState: false,
    goToState: false,
    mapCenter: null
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) {
      this.loadClientModules();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      baseMaps,
      isAtlas,
      layers,
      map,
      updateLayerMapState,
      popupProp,
      leafletMapId,
      handleMapLoaded
    } = this.props;
    const {
      aiInterestArea,
      clientModulesReady,
      currentLocationState,
      goToState,
      isLeafletMapLoaded,
      isMapMapLoaded
    } = this.state;
    const { layers: prevLayers, baseMaps: prevBaseMaps, map: prevMap } = prevProps;
    const {
      currentLocationState: prevCurrentLocationState,
      aiInterestArea: prevAIInterestArea,
      goToState: prevGoToState
    } = prevState;
    let forceupdate = false;
    let forceupdateMap = false;
    let forceupdateLeafletButton = false;
    const hasSharedUpdated = mapOps.isShared(prevMap) !== mapOps.isShared(map);
    const hasMapCenterUpdated = !isEqual(
      mapOps.getMapLocation(prevMap),
      mapOps.getMapLocation(map)
    );
    const haveSelectedButtonsChanged = !isEqual(
      mapOps.getSelectedButtons(prevMap),
      mapOps.getSelectedButtons(map)
    );
    const areButtonsUpdated = hasSharedUpdated || hasMapCenterUpdated || haveSelectedButtonsChanged;

    if (clientModulesReady && isLeafletMapLoaded && !isMapMapLoaded && initializeLoaded) {
      initializeLoaded = false;
      if (leafletMapId.includes('imaps')) handleMapLoaded(false, {});
      this.initializeMap();
    }

    if (isMapMapLoaded && isLeafletMapLoaded) {
      this.mapMap.invalidateSize(true);
    }

    if (isMapMapLoaded && !isEqual(mapOps.getBackground(map), mapOps.getBackground(prevMap))) {
      const mapId = isAtlas ? this.randomMapId : leafletMapId;
      document.getElementById(mapId).style.background = mapOps.getBackground(map);
    }

    if (!isEqual(layers, oldLayers[0])) {
      forceupdate = true;
      oldLayers[0] = cloneDeep(layers);
    } else {
      forceupdate = false;
    }

    if (!isEqual(map, oldMap[0])) {
      forceupdateMap = true;
      oldMap[0] = cloneDeep(map);
    } else {
      forceupdateMap = false;
    }
    if (
      !isEqual(prevCurrentLocationState, currentLocationState) ||
      !isEqual(prevGoToState, goToState)
    ) {
      forceupdateLeafletButton = true;
    } else {
      forceupdateLeafletButton = false;
    }
    if (isMapMapLoaded) {
      estado =
        !isEqual(prevLayers, layers) ||
        !isEqual(prevBaseMaps, baseMaps) ||
        forceupdate === true ||
        forceupdateMap === true;
      if (estado === true) {
        const leafletObjectResults = await drawMapLayers({
          layers,
          baseMaps,
          popupProp,
          leafletMap: this.mapMap,
          layersOverlayed: mapOps.areLayersOverlayed(map),
          layersToDisplay: this.layersToDisplay,
          baseMapsToDisplay: this.baseMapsToDisplay,
          isUpdate: true,
          baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
          layersTransparency: mapOps.getLayersTransparency(map),
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          layerVisibilitySettings: mapOps.getLayersVisibility(map),
          layerSideBySide: {
            state: useTimeStore.getState().isSideBySide,
            layerSide: useTimeStore.getState().layerSide
          }
        });
        this.layersToDisplay = leafletObjectResults.newLayersToDraw;
        this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMap,
          layers,
          layersToDisplay: this.layersToDisplay,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplay,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMap,
          locationButton: true,
          currentLocationState,
          locationFunction: this.currentLocation,
          goToState,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocation
        });
        drawMapInterestArea({
          aiInterestArea,
          aiInterestAreaLayer: this.aiInterestAreaLayer,
          isUpdate: true,
          leafletMap: this.mapMap
        });
        if (!isEmpty(aiInterestArea)) {
          this.mapMap.removeControl(this.aiInterestAreaDrawControl);
        }
        if (mapOps.showDrawControl(map)) {
          showGeometryEditControls({
            leafletMap: this.mapMap,
            drawControl: this.aiInterestAreaDrawControl,
            editControl: this.aiInterestAreaEditControl,
            defineGeometryActive: true,
            geometryLayer: this.aiInterestAreaLayer
          });
        }

        updateLayerMapState(false);
      } else if (areButtonsUpdated || forceupdateLeafletButton === true) {
        drawCustomButtons({
          map,
          type: 'map',
          leafletMap: this.mapMap,
          layers,
          layersToDisplay: this.layersToDisplay,
          baseMaps,
          baseMapsToDisplay: this.baseMapsToDisplay,
          baseMapsZoom: mapOps.getBaseMapsZoom(map),
          layersZoom: mapOps.getLayersZoom(map),
          reloadButton: true,
          reloadFunction: this.reloadMap,
          locationButton: true,
          locationFunction: this.currentLocation,
          goToState,
          gotoLocationButton: true,
          gotoLocationFunction: this.gotoLocation,
          currentLocationState
        });
      }
      if (
        (!isEqual(aiInterestArea, prevAIInterestArea) || forceupdateLeafletButton === true) &&
        estado === false
      ) {
        drawMapInterestArea({
          aiInterestArea,
          aiInterestAreaLayer: this.aiInterestAreaLayer,
          isUpdate: true,
          leafletMap: this.mapMap
        });
        if (!isEmpty(aiInterestArea)) {
          this.mapMap.removeControl(this.aiInterestAreaDrawControl);
        }
        if (mapOps.showDrawControl(map)) {
          showGeometryEditControls({
            leafletMap: this.mapMap,
            drawControl: this.aiInterestAreaDrawControl,
            editControl: this.aiInterestAreaEditControl,
            defineGeometryActive: true,
            geometryLayer: this.aiInterestAreaLayer
          });
        }

        this.expandirDesplegable();
      }
    }
    this.createMapCenter();
  }

  componentWillUnmount() {
    const { layers, baseMaps } = this.props;

    forEach(layers, layer => {
      if (layerOps.isRealTime(layer) || layerOps.isAnnotationsRealTime(layer)) {
        this.layersToDisplay[layerOps.getName(layer)].stop();
      }
    });

    forEach(baseMaps, baseMap => {
      if (layerOps.isRealTime(baseMap)) {
        this.baseMapsToDisplay[layerOps.getName(baseMap)].stop();
      }
    });
    useTimeStore.setState({ isMapLoaded: false });
  }

  actualizarFunction = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpate, error, options);
  };

  actualizarGoToFunction = () => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 5000
    };
    navigator.geolocation.getCurrentPosition(this.calculateUpateGoTo, error, options);
  };

  calculateUpateGoTo = pos => {
    if (!isEmpty(marker)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      // eslint-disable-next-line no-underscore-dangle
      const to = turf.point([marker._latlng.lng, marker._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        const radius = pos.coords.accuracy;
        marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
        circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMap);
        this.mapMap.panTo([pos.coords.latitude, pos.coords.longitude]);
      }
    }
  };

  calculateDrawGoToLocation = pos => {
    const radius = pos.coords.accuracy;
    marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
    circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMap);
    this.mapMap.panTo([pos.coords.latitude, pos.coords.longitude]);
    intervaloGoToFunction = setInterval(this.actualizarGoToFunction, 5000);
  };

  calculateDrawLocation = pos => {
    const radius = pos.coords.accuracy;
    marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
    circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
      color: 'blue',
      fillColor: 'blue'
    }).addTo(this.mapMap);
    intervaloFunction = setInterval(this.actualizarFunction, 5000);
  };

  calculateUpate = pos => {
    if (!isEmpty(marker)) {
      const from = turf.point([pos.coords.longitude, pos.coords.latitude]);
      // eslint-disable-next-line no-underscore-dangle
      const to = turf.point([marker._latlng.lng, marker._latlng.lat]);
      const options = { units: 'meters' };
      const distance = turf.distance(from, to, options);

      if (distance > 8) {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        const radius = pos.coords.accuracy;
        marker = L.marker([pos.coords.latitude, pos.coords.longitude]).addTo(this.mapMap);
        circle = L.circle([pos.coords.latitude, pos.coords.longitude], radius, {
          color: 'blue',
          fillColor: 'blue'
        }).addTo(this.mapMap);
      }
    }
  };

  convertirDistancia = metros => {
    const kilometros = Math.floor(metros / 1000);
    if (kilometros === 0) {
      return `${metros}m`;
    }
    const metrosRestantes = Math.floor(metros - kilometros * 1000);
    return `${kilometros}km ${metrosRestantes}m`;
  };

  convertirSegundos = segundos => {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const segundosRestantes = Math.floor(segundos % 60);
    if (horas === 0 && minutos !== 0) {
      return `${minutos}m ${segundosRestantes}s`;
    }
    if (horas === 0 && minutos === 0) {
      return `${segundosRestantes}s`;
    }
    return `${horas}h ${minutos}m ${segundosRestantes}s`;
  };

  createMapCenter = () => {
    const { map } = this.props;
    const { isMapMapLoaded } = this.state;
    if (isEmpty(mapOps.getMapLocation(map)) && isMapMapLoaded) {
      this.updateMapCenter();
    }
  };

  currentLocation = () => {
    const { currentLocationState, goToState, isMapMapLoaded } = this.state;
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };

    if (isMapMapLoaded) {
      if (currentLocationState === false) {
        if (goToState === true) {
          this.mapMap.removeLayer(marker);
          this.mapMap.removeLayer(circle);
          clearInterval(intervaloGoToFunction);
          this.setState({ goToState: false });
        }
        navigator.geolocation.getCurrentPosition(this.calculateDrawLocation, error, options);
        this.setState({ currentLocationState: true });
      } else {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        clearInterval(intervaloFunction);
      }
    }
    this.setState({ currentLocationState: !currentLocationState });
  };

  deleteMarkers = () => {
    this.mapMap.off('click');
    if (markerRoute && !isEmpty(markerRoute)) {
      markerRoute.forEach(item => {
        this.mapMap.removeLayer(item);
      });
      markerRoute.length = 0;
    }
  };

  drawLayerSideBySide = async () => {
    const { baseMaps, layers, map, popupProp } = this.props;
    const { aiInterestArea, currentLocationState, goToState } = this.state;
    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      popupProp,
      leafletMap: this.mapMap,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplay,
      baseMapsToDisplay: this.baseMapsToDisplay,
      isUpdate: true,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      layerVisibilitySettings: mapOps.getLayersVisibility(map),
      layerSideBySide: {
        state: useTimeStore.getState().isSideBySide,
        layerSide: useTimeStore.getState().layerSide
      }
    });
    this.layersToDisplay = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMap,
      layers,
      layersToDisplay: this.layersToDisplay,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMap,
      locationButton: true,
      currentLocationState,
      locationFunction: this.currentLocation,
      goToState,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocation
    });
    drawMapInterestArea({
      aiInterestArea,
      aiInterestAreaLayer: this.aiInterestAreaLayer,
      isUpdate: true,
      leafletMap: this.mapMap
    });
    if (!isEmpty(aiInterestArea)) {
      this.mapMap.removeControl(this.aiInterestAreaDrawControl);
    }
    if (mapOps.showDrawControl(map)) {
      showGeometryEditControls({
        leafletMap: this.mapMap,
        drawControl: this.aiInterestAreaDrawControl,
        editControl: this.aiInterestAreaEditControl,
        defineGeometryActive: true,
        geometryLayer: this.aiInterestAreaLayer
      });
    }
  };

  drawGeometriesNotes = async (coordOnMap, setCoordOnMap, showNotesOnMap, setShowNotesOnMap) => {
    const { leafletMapId } = this.props;
    const { coordsAnnotationClick } = this.state;
    const {
      showEnable,
      enableCenter,
      annotations,
      selectAnnotation,
      videos,
      selectVideo,
      methodEditor,
      handleAnnotation
    } = showNotesOnMap;
    if (!leafletMapId.includes('imaps')) {
      const redIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      const yellowIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      const blueIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });

      if (!isEmpty(manyMarkerAnnotationsClick)) {
        manyMarkerAnnotationsClick.map(element => {
          return this.mapMap.removeLayer(element);
        });
      }

      if (!isEmpty(markerCoordVideoPoint)) {
        markerCoordVideoPoint.map(element => {
          return this.mapMap.removeLayer(element);
        });
      }

      const addPointOnMapNotes = e => {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        const newPointTrack = [lat, lng];
        if (!isEmpty(markerAnnotationCLick)) {
          this.mapMap.removeLayer(markerAnnotationCLick);
        }
        if (!isEmpty(markerAnnotationsProyected)) {
          this.mapMap.removeLayer(markerAnnotationsProyected);
        }
        markerAnnotationCLick = L.marker(newPointTrack, { icon: redIcon })
          .bindPopup('New point create annotation')
          .openPopup()
          .addTo(this.mapMap);
        if (!isEmpty(newPointTrack)) {
          setCoordOnMap({ lat, lng });
          this.setState({ coordsAnnotationClick: { lat, lng } });
        }
        const isVideoLine = !isEqual(
          VIDEO_COORDINATE_DATA_TYPES.POINT,
          videoOps.getCoordinatesDataType(selectVideo)
        );
        if (!isEmpty(newPointTrack) && !isEmpty(selectVideo) && isVideoLine) {
          const trackVideo = videoOps.getTrack(selectVideo);
          const coordsVideo = trackVideo.geometry.coordinates;
          const turfLine = turf.lineString(coordsVideo);
          const newPointTurf = turf.point([lng, lat]);
          const newPointVideo = turf.nearestPointOnLine(turfLine, newPointTurf);
          const { coordinates } = newPointVideo.geometry;
          markerAnnotationsProyected = L.marker([coordinates[1], coordinates[0]], {
            icon: yellowIcon
          }).addTo(this.mapMap);
          if (!isEmpty(newPointVideo))
            setShowNotesOnMap({ ...showNotesOnMap, proyectedPoint: newPointVideo });
        }
      };

      if (enableCenter) {
        if (!isEmpty(selectAnnotation)) {
          const geoJsonAnnotation = annotationOps.getGeoJSON(selectAnnotation);
          const { coordinates } = geoJsonAnnotation.geometry;
          const longAnnotation = coordinates[0];
          const latAnnotation = coordinates[1];
          this.mapMap.setView([latAnnotation, longAnnotation]);
        } else if (!isEmpty(selectVideo)) {
          const latlong = videoOps.getLatLng0(selectVideo);
          const longAnnotation = latlong[0];
          const latAnnotation = latlong[1];
          this.mapMap.setView([latAnnotation, longAnnotation]);
        }
      }

      if (showEnable) {
        let updateAnnotations = false;
        if (!isEmpty(this.annotationsLayer)) updateAnnotations = true;
        this.annotationsLayer = await drawVideoAnnotations({
          leafletMap: this.mapMap,
          annotations,
          isUpdate: updateAnnotations,
          annotationsLayer: this.annotationsLayer,
          selectAnnotation,
          onClickFunction: newAnnotation => handleAnnotation(newAnnotation, selectVideo)
        });

        const videoPoints = filter(videos, video =>
          isEqual(VIDEO_COORDINATE_DATA_TYPES.POINT, videoOps.getCoordinatesDataType(video))
        );

        if (!isEmpty(this.trackVideoLayer)) this.trackVideoLayer.map(layer => layer.clearLayers());

        this.trackVideoLayer = videos.map(vid => {
          const track = videoOps.getTrack(vid);
          return drawVideoTrack({
            leafletMap: this.mapMap,
            track,
            colorTrack: 'red'
          });
        });

        if (!isEmpty(videoPoints)) {
          markerCoordVideoPoint = videoPoints.map(vid => {
            const latlong = videoOps.getLatLng0(vid);
            const videoPoint = [latlong[1], latlong[0]];
            return L.marker(videoPoint, {
              icon: blueIcon
            }).addTo(this.mapMap, this.mapMap.getZoom());
          });
        }
      } else {
        if (!isEmpty(this.annotationsLayer)) await this.annotationsLayer.clearLayers();
        if (!isEmpty(this.trackVideoLayer)) this.trackVideoLayer.map(layer => layer.clearLayers());
        if (!isEmpty(markerCoordVideoPoint)) {
          markerCoordVideoPoint.map(element => {
            return this.mapMap.removeLayer(element);
          });
        }
      }

      if (!isEqual(methodEditor, 'close')) {
        switch (methodEditor) {
          case 'create' || 'json':
            if (!isEmpty(coordsAnnotationClick)) {
              const { lat } = coordsAnnotationClick;
              const { lng } = coordsAnnotationClick;
              manyAnnotationClick.push([lat, lng]);
            }
            if (manyAnnotationClick.length > 0) {
              manyMarkerAnnotationsClick = manyAnnotationClick.map(element => {
                return L.marker(element, { icon: redIcon })
                  .bindPopup('Annotation Maps point')
                  .openPopup()
                  .addTo(this.mapMap);
              });
            }
            Bert.alert('Click on map', 'info');
            this.mapMap.off('click');
            this.mapMap.on('click', addPointOnMapNotes);
            break;

          case 'annotation':
            if (!isEmpty(coordOnMap)) {
              const { lat } = coordOnMap;
              const { lng } = coordOnMap;
              const newPointTrack = [lat, lng];
              markerAnnotationCLick = L.marker(newPointTrack, { icon: redIcon })
                .bindPopup('Annotation Maps point')
                .openPopup()
                .addTo(this.mapMap);

              if (!isEmpty(selectVideo)) {
                const trackVideo = videoOps.getTrack(selectVideo);
                const coordsTrack = trackVideo.geometry.coordinates;
                const turfLine = turf.lineString(coordsTrack);
                const newPointTurf = turf.point([lng, lat]);
                const newPointVideo = turf.nearestPointOnLine(turfLine, newPointTurf);
                const { coordinates } = newPointVideo.geometry;
                markerAnnotationsProyected = L.marker([coordinates[1], coordinates[0]], {
                  icon: yellowIcon
                }).addTo(this.mapMap);
                setShowNotesOnMap({ ...showNotesOnMap, proyectedPoint: newPointVideo });
              }
            }
            break;

          default:
            break;
        }
      } else {
        manyAnnotationClick.splice(0, manyAnnotationClick.length);
        if (!isEmpty(manyMarkerAnnotationsClick)) {
          manyMarkerAnnotationsClick.map(element => {
            return this.mapMap.removeLayer(element);
          });
        }
        if (!isEmpty(markerAnnotationCLick)) {
          this.mapMap.removeLayer(markerAnnotationCLick);
        }
        if (!isEmpty(markerAnnotationsProyected)) {
          this.mapMap.removeLayer(markerAnnotationsProyected);
        }
        setCoordOnMap({});
        this.setState({ coordsAnnotationClick: {} });
      }
    }
  };

  drawGeometriesTemplates = coordsAnnotationTemplate => {
    const { leafletMapId } = this.props;
    if (leafletMapId.includes('imaps')) {
      const greenIcon = new L.Icon({
        iconUrl:
          'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });

      if (!isEmpty(markerAnnotationImaps)) {
        this.mapMap.removeLayer(markerAnnotationImaps);
      }

      if (!isEmpty(coordsAnnotationTemplate)) {
        const geoJsonAnnotation = annotationOps.getGeoJSON(coordsAnnotationTemplate);
        const { coordinates } = geoJsonAnnotation.geometry;
        const longAnnotation = coordinates[0];
        const latAnnotation = coordinates[1];
        markerAnnotationImaps = L.marker([latAnnotation, longAnnotation], {
          icon: greenIcon
        })
          .bindPopup('Annotation IMAPS')
          .openPopup()
          .addTo(this.mapMap, this.mapMap.getZoom());
      }
    }
  };

  drawPointsRouteFunction = ({ setPointsRoute }) => {
    const puntosSeleccionados = [];
    const coloresPuntos = { inicio: '#008000', intermedio: '#FFA500', final: '#FF0000' };
    const agregarPunto = latlng => {
      const puntoFormateado = [latlng.lng, latlng.lat];
      puntosSeleccionados.push(puntoFormateado);

      let color;
      if (puntosSeleccionados.length === 1) {
        color = coloresPuntos.inicio;
      } else if (puntosSeleccionados.length === 2) {
        color = coloresPuntos.final;
      } else {
        color = coloresPuntos.intermedio;
      }

      setPointsRoute(puntosSeleccionados);

      const newMarker = L.circleMarker(latlng, {
        color,
        radius: 8,
        fillOpacity: 1
      }).addTo(this.mapMap);

      markerRoute.push(newMarker);
    };
    this.mapMap.off('click');
    this.mapMap.on('click', e => {
      agregarPunto(e.latlng);
    });
  };

  drawRouteFunction = ({ drawRoute }) => {
    if (routes && !isEmpty(routes)) {
      routes.forEach(polyline => this.mapMap.removeLayer(polyline));
    }
    const coloresPredefinidos = ['#008000', '#FFFF00', '#FF0000']; // Verde, amarillo, rojo

    const generarColor = (index, totalRutas) => {
      const posicionDesdeElFinal = totalRutas - index - 1;
      if (posicionDesdeElFinal < coloresPredefinidos.length) {
        return coloresPredefinidos[posicionDesdeElFinal];
      }
      return `#${Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, '0')}`;
    };

    if (drawRoute && !isEmpty(drawRoute)) {
      // Ordenar las rutas por duración, de mayor a menor
      const rutasOrdenadas = [...drawRoute.data].sort((a, b) => a.duration - b.duration).reverse();

      rutasOrdenadas.forEach((ruta, index) => {
        const coordenadas = ruta.route.map(step => [step[1], step[0]]);
        // Generar el color basado en el índice y el número total de rutas
        const color = generarColor(index, rutasOrdenadas.length);
        const polyline = L.polyline(coordenadas, {
          color,
          weight: 5,
          smoothFactor: 1
        }).addTo(this.mapMap);

        polyline
          .bindTooltip(
            `La duración es de ${this.convertirSegundos(
              ruta.duration
            )} y la distancia son ${this.convertirDistancia(ruta.distance)}`
          )
          .openTooltip();

        routes.push(polyline);
      });

      // Ajustar el mapa para centrarlo en las rutas, si es necesario
      if (drawRoute.centerOnRoute && drawRoute.centerOnRoute === true) {
        const bounds = L.featureGroup(routes).getBounds();
        if (bounds && !isEmpty(bounds)) {
          this.mapMap.fitBounds(bounds);
        }
      }
    }
  };

  drawToDownload = ({ setCoordOnMap, geometryConfig, setDataToSend }) => {
    const redIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    const yellowIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    const blueIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    const addPointOnMap = e => {
      if (!isEmpty(markerDownload)) {
        this.mapMap.removeLayer(markerDownload);
      }
      if (geometryConfig === 'punto') {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setCoordOnMap({ lat, lng });
      } else if (
        geometryConfig === 'StreetView' ||
        geometryConfig === 'Catastro' ||
        geometryConfig === 'LocationComponent'
      ) {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setCoordOnMap({ lat, lng });
        if (geometryConfig === 'Catastro' || geometryConfig === 'LocationComponent') {
          markerDownload = L.marker([lat, lng], { icon: yellowIcon }).addTo(this.mapMap);
        } else if (geometryConfig === 'StreetView') {
          markerDownload = L.marker([lat, lng], { icon: redIcon })
            .bindPopup('Street view point')
            .openPopup()
            .addTo(this.mapMap);
        }
      } else if (geometryConfig === 'directButton') {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setCoordOnMap({ lat, lng });
        markerDownload = L.marker([lat, lng], { icon: blueIcon })
          .bindPopup('Last annotation')
          .openPopup()
          .addTo(this.mapMap);
      } else if (
        geometryConfig === 'otros' ||
        geometryConfig === 'Catastro' ||
        geometryConfig === 'LocationComponent'
      ) {
        const { lat } = e.latlng;
        const { lng } = e.latlng;
        setDataToSend({ lat, lng });
      } else if (geometryConfig === 'sentinel') {
        if (markersPolygonDownload.length === 0) {
          const popupContent = 'Clickea en otra zona para crear un rectángulo';
          const popup = L.popup({ autoClose: false, closeOnClick: false }).setContent(popupContent);
          marker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
          marker.bindPopup(popup);
          marker.openPopup();
          markersPolygonDownload.push(marker);
        } else if (markersPolygonDownload.length === 1) {
          const secondmarker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
          markersPolygonDownload.push(secondmarker);

          const polygonCoordinates = markersPolygonDownload.map(element => {
            const coordenadas = element.getLatLng();
            return [coordenadas.lat, coordenadas.lng];
          });
          const polygonGeometry = L.rectangle(polygonCoordinates, {
            color: 'blue',
            fillOpacity: 0.3,
            pane: '1000'
          });
          setDataToSend(polygonCoordinates);
          markerDownload = polygonGeometry.addTo(this.mapMap);
          markersPolygonDownload.map(element => this.mapMap.removeLayer(element));
          if (!isEmpty(markersPolygonDownload)) {
            markersPolygonDownload = [];
          }
        }
      } else if (geometryConfig === 'poligono') {
        if (markersPolygonDownload.length === 0) {
          const popupContent = 'Clickear este primer punto para cerrar el polígono';
          const popup = L.popup({ autoClose: false, closeOnClick: false }).setContent(popupContent);
          marker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
          marker.bindPopup(popup);
          marker.openPopup();
        } else {
          marker = L.marker(e.latlng, { icon: yellowIcon }).addTo(this.mapMap);
        }
        markersPolygonDownload.push(marker);
        if (markersPolygonDownload.length >= 3) {
          markersPolygonDownload.forEach((item, index) => {
            item.on('click', () => {
              if (index === 0) {
                item.off('click');
                const polygonCoordinates = markersPolygonDownload.map(element => {
                  const coordenadas = element.getLatLng();
                  return [coordenadas.lat, coordenadas.lng];
                });
                setDataToSend(polygonCoordinates);
                const polygonGeometry = L.polygon(polygonCoordinates, {
                  color: 'blue',
                  fillOpacity: 0.3,
                  pane: '1000'
                });
                markerDownload = polygonGeometry.addTo(this.mapMap);
                markersPolygonDownload.map(element => this.mapMap.removeLayer(element));
                if (!isEmpty(markersPolygonDownload)) {
                  markersPolygonDownload = [];
                }
              }
            });
          });
        }
      }
    };
    if (!isEmpty(markerDownload)) {
      this.mapMap.removeLayer(markerDownload);
      markerDownload = {};
    }
    if (!isEmpty(markersPolygonDownload)) {
      markersPolygonDownload.map(element => this.mapMap.removeLayer(element));
      markersPolygonDownload = [];
    }
    if (
      geometryConfig === 'punto' ||
      geometryConfig === 'otros' ||
      geometryConfig === 'Catastro' ||
      geometryConfig === 'StreetView' ||
      geometryConfig === 'directButton' ||
      geometryConfig === 'LocationComponent'
    ) {
      this.mapMap.off('click');
      this.mapMap.on('click', addPointOnMap);
    } else if (geometryConfig === 'poligono' || geometryConfig === 'sentinel') {
      this.mapMap.off('click');
      this.mapMap.on('click', addPointOnMap);
    } else if (geometryConfig === 'none' || geometryConfig === 'component') {
      this.mapMap.off('click');
    }
  };

  expandirDesplegable = () => {
    this.mapMap.collapseButton.expand();
  };

  getCurrentMapState = () => {
    return {
      itemType: 'leafletMap',
      leafletMap: this.mapMap,
      defineGeometryActive: true,
      geometryLayer: this.aiInterestAreaLayer,
      drawControl: this.aiInterestAreaDrawControl,
      editControl: this.aiInterestAreaEditControl,
      setAtlasGeometry: this.setAIInterestArea
    };
  };

  goToCoordinatesFunction = ({ geometryConfig, goToCoordinates, setGoToCoordinates }) => {
    const { map } = this.props;
    const orangeIcon = new L.Icon({
      iconUrl:
        'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    if (
      goToCoordinates[0] !== 0 &&
      goToCoordinates[1] !== 0 &&
      typeof goToCoordinates[0] === 'number' &&
      typeof goToCoordinates[1] === 'number'
    ) {
      if (
        geometryConfig === 'punto' ||
        geometryConfig === 'otros' ||
        geometryConfig === 'Catastro' ||
        geometryConfig === 'input' ||
        geometryConfig === 'LocationComponent'
      ) {
        if (!isEmpty(markerDownload)) {
          this.mapMap.removeLayer(markerDownload);
          markerDownload = {};
        }
        markerDownload = L.marker(goToCoordinates, { icon: orangeIcon }).addTo(this.mapMap);

        if (geometryConfig === 'LocationComponent') {
          this.mapMap.setView(goToCoordinates, map.settingsAdvancedMap.locationSettings.zoom);
        }
      }

      this.mapMap.flyTo(goToCoordinates);
      setGoToCoordinates([0, 0]);
    }
  };

  gotoLocation = () => {
    const { currentLocationState, goToState, isMapMapLoaded } = this.state;

    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    const options = {
      enableHighAccuracy: false,
      // timeout: 5000,
      maximumAge: 5000
    };
    if (isMapMapLoaded) {
      if (goToState === false) {
        if (currentLocationState === true) {
          this.mapMap.removeLayer(marker);
          this.mapMap.removeLayer(circle);
          clearInterval(intervaloFunction);
          this.setState({ currentLocationState: false });
        }
        navigator.geolocation.getCurrentPosition(this.calculateDrawGoToLocation, error, options);
      } else {
        this.mapMap.removeLayer(marker);
        this.mapMap.removeLayer(circle);
        clearInterval(intervaloGoToFunction);
      }
    }
    this.setState({ goToState: !goToState });
  };

  locationList = async () => {
    const { map } = this.props;

    localforage.getItem(`userLocation`).then(geojsonContent => {
      const arrayLocal = isEmpty(geojsonContent) ? [] : JSON.parse(geojsonContent);
      navigator.geolocation.getCurrentPosition(position => {
        const coordinates = [position.coords.latitude, position.coords.longitude];
        const newCoordinates = {
          coordinates,
          loginId: isEmpty(arrayLocal) ? uuid() : arrayLocal[arrayLocal.length - 1].loginId,
          mapId: map._id,
          mapName: map.name,
          key: uuid(),
          userId: map.owner,
          time: `${`${new Date().getDate()}-${new Date().getMonth() +
            1}-${new Date().getFullYear()}` +
            ' '}${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
        };
        sendCoordinates = [newCoordinates];
        if (isEmpty(arrayToSendCoordinates)) {
          arrayToSendCoordinates = [newCoordinates];
        } else {
          arrayToSendCoordinates.push(newCoordinates);
        }
        const allCoordinates = [...arrayLocal, newCoordinates];
        localforage.setItem(`userLocation`, JSON.stringify(allCoordinates));
      });
    });
    if (timeCoordinates > 20) {
      try {
        if (!isEmpty(sendCoordinates)) {
          await methodPromise('maps.sendUserLocation', { userLocation: sendCoordinates });
          sendCoordinates = [];
        }
      } catch (error) {
        handleErrorInClient(error);
      }
    }
  };

  updateMapCenter = async () => {
    const { isMapMapLoaded } = this.state;
    const { map } = this.props;
    if (isMapMapLoaded) {
      const currentMapCenter = latlong2featurePoint(this.mapMap.getCenter().wrap());
      featureSetZoom(currentMapCenter, this.mapMap.getZoom());
      featureSetBBox(
        currentMapCenter,
        getBBoxFromCoordsAndZoom({ map: this.mapMap, mapLocation: currentMapCenter })
      );
      try {
        await methodPromise('maps.updateMapLocation', mapOps.getId(map), currentMapCenter);
        if (mapOps.showHomeButton(map)) {
          this.mapMap.removeControl(this.mapMap.homeButton);
          customHomeButton(this.mapMap, currentMapCenter);
        }
        Bert.alert('Map Updated!', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    } else {
      Bert.alert('Map Not Loaded!', 'warning');
    }
  };

  updateMapState = newState => {
    this.setState({ isLeafletMapLoaded: newState });
  };

  sendUserLocation = async () => {
    if (!isEmpty(sendCoordinates)) {
      try {
        await methodPromise('maps.sendUserLocation', { userLocation: arrayToSendCoordinates });
      } catch (error) {
        handleErrorInClient(error);
      }
    }
    arrayToSendCoordinates = [];
  };

  setAIInterestArea = newAIInterestArea => this.setState({ aiInterestArea: newAIInterestArea });

  initializeMap = async () => {
    const {
      baseMaps,
      isAtlas,
      layers,
      map,
      updateLayerMapState,
      popupProp,
      externalBoton,
      updateLocation,
      userControlSetting,
      leafletMapId,
      handleMapLoaded
    } = this.props;
    const { aiInterestArea, currentLocationState, goToState } = this.state;
    let mapLocation = mapOps.getMapLocation(map);
    if (isEmpty(mapLocation)) {
      if (!isNil(Meteor.user())) {
        mapLocation = userControlSetting.defaultMapCenter;
      } else {
        mapLocation = defaultMapCenter;
      }
    }

    this.mapMap = get(this, 'mapMapComponent.current.leafletMap');
    this.mapMap.setView(
      featurePoint2LatLng(getMapCenter({ location: mapLocation })),
      featureGetZoom(mapLocation)
    );

    const mapId = isAtlas ? this.randomMapId : leafletMapId;
    document.getElementById(mapId).style.background = mapOps.getBackground(map);

    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      popupProp,
      leafletMap: this.mapMap,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplay,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      layerVisibilitySettings: mapOps.getLayersVisibility(map),
      layerSideBySide: {
        state: useTimeStore.getState().isSideBySide,
        layerSide: useTimeStore.getState().layerSide
      }
    });
    this.layersToDisplay = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMap,
      layers,
      layersToDisplay: this.layersToDisplay,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMap,
      locationButton: true,
      currentLocationState,
      locationFunction: this.currentLocation,
      goToState,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocation
    });
    this.aiInterestAreaLayer = drawMapInterestArea({
      aiInterestArea,
      leafletMap: this.mapMap
    });
    const aiInterestAreaControls = createGeometryDrawControlsMaps({
      drawnItems: this.aiInterestAreaLayer
    });
    this.aiInterestAreaDrawControl = aiInterestAreaControls.drawControlFull;
    this.aiInterestAreaEditControl = aiInterestAreaControls.drawControlEdit;

    addDrawEventListenersMaps({
      limitation: false,
      leafletMap: this.mapMap,
      getCurrentMapState: this.getCurrentMapState,
      editControl: this.aiInterestAreaEditControl
    });
    if (mapOps.showDrawControl(map)) {
      showGeometryEditControls({
        leafletMap: this.mapMap,
        drawControl: this.aiInterestAreaDrawControl,
        editControl: this.aiInterestAreaEditControl,
        defineGeometryActive: true,
        geometryLayer: this.aiInterestAreaLayer
      });
    }

    this.mapMap.on('moveend', () => {
      const currentMapCenter = this.mapMap.getCenter().wrap();
      currentMapCenter.zoom = this.mapMap.getZoom();
      if (!externalBoton || leafletMapId.includes('imaps')) {
        updateLocation(currentMapCenter);
      }
      this.setState({ mapCenter: currentMapCenter });
    });
    if (mapOps.showMiniMap(map) === true) {
      const baseLayer = L.tileLayer(baseMaps[0].url, baseMaps[0].options || {});
      const miniMap = new MiniMap(baseLayer, {
        toggleDisplay: true,
        collapsedWidth: 25,
        collapsedHeight: 25,
        mapOptions: {
          dragging: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
          touchZoom: false
        }
      });
      miniMap.addTo(this.mapMap);
    }
    this.setState({ isMapMapLoaded: true });
    initializeLoaded = true;
    updateLayerMapState(false);
    if (leafletMapId.includes('imaps')) {
      handleMapLoaded(true, this.mapMap);
    }
    useTimeStore.setState({ isMapLoaded: true });
  };

  reloadMap = async () => {
    const { baseMaps, layers, map, popupProp, updateLayerMapState } = this.props;
    const { aiInterestArea, currentLocationState, goToState } = this.state;
    const leafletObjectResults = await drawMapLayers({
      layers,
      baseMaps,
      popupProp,
      leafletMap: this.mapMap,
      layersOverlayed: mapOps.areLayersOverlayed(map),
      layersToDisplay: this.layersToDisplay,
      baseMapsToDisplay: this.baseMapsToDisplay,
      isUpdate: true,
      baseMapsTransparency: mapOps.getBaseMapsTransparency(map),
      layersTransparency: mapOps.getLayersTransparency(map),
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      layerVisibilitySettings: mapOps.getLayersVisibility(map),
      layerSideBySide: {
        state: useTimeStore.getState().isSideBySide,
        layerSide: useTimeStore.getState().layerSide
      }
    });
    this.layersToDisplay = leafletObjectResults.newLayersToDraw;
    this.baseMapsToDisplay = leafletObjectResults.newBaseMapsToDraw;
    drawCustomButtons({
      map,
      type: 'map',
      leafletMap: this.mapMap,
      layers,
      layersToDisplay: this.layersToDisplay,
      baseMaps,
      baseMapsToDisplay: this.baseMapsToDisplay,
      baseMapsZoom: mapOps.getBaseMapsZoom(map),
      layersZoom: mapOps.getLayersZoom(map),
      reloadButton: true,
      reloadFunction: this.reloadMap,
      locationButton: true,
      currentLocationState,
      locationFunction: this.currentLocation,
      gotoLocationButton: true,
      gotoLocationFunction: this.gotoLocation,
      goToState
    });
    drawMapInterestArea({
      aiInterestArea,
      aiInterestAreaLayer: this.aiInterestAreaLayer,
      isUpdate: true,
      leafletMap: this.mapMap
    });
    if (!isEmpty(aiInterestArea)) {
      this.mapMap.removeControl(this.aiInterestAreaDrawControl);
    }
    if (mapOps.showDrawControl(map)) {
      showGeometryEditControls({
        leafletMap: this.mapMap,
        drawControl: this.aiInterestAreaDrawControl,
        editControl: this.aiInterestAreaEditControl,
        defineGeometryActive: true,
        geometryLayer: this.aiInterestAreaLayer
      });
    }

    if (this.mapMap.collapseButton) this.mapMap.collapseButton.expand();
    updateLayerMapState(false);
    Bert.alert('Map Updated!', 'success');
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      L = await import('leaflet');
      await import('leaflet-draw');
      localforage = await import('localforage');
      MiniMap = (await import('leaflet-minimap')).default;
      ({
        addDrawEventListenersMaps,
        createGeometryDrawControlsMaps,
        customHomeButton,
        drawCustomButtons,
        drawMapLayers,
        drawMapInterestArea,
        getBBoxFromCoordsAndZoom,
        getMapCenter,
        showGeometryEditControls,
        drawVideoAnnotations,
        drawVideoTrack
      } = await import('../../../modules/leaflet-operations'));
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const {
      baseMaps,
      deployEnv,
      externalBoton,
      isAtlas,
      isFullScreen,
      isPublicMap,
      layers,
      map,
      leafletMapId,
      showReloadPosition
    } = this.props;
    const { isMapMapLoaded, mapCenter } = this.state;
    const showBaseMapSelector = mapOps.showBaseMapSelector(map) && !isEmpty(baseMaps);
    const showLayerSelector = mapOps.showLayerSelector(map) && !isEmpty(layers);

    let numberOfButtonsRight = 0;
    if (showBaseMapSelector) numberOfButtonsRight += 1;
    if (showLayerSelector) numberOfButtonsRight += 1;

    const mapId = isAtlas ? this.randomMapId : leafletMapId;
    return (
      <>
        {externalBoton && (
          <ExportProviderMap
            currentLocation={this.currentLocation}
            deleteMarkers={this.deleteMarkers}
            drawGeometriesNotes={this.drawGeometriesNotes}
            drawGeometriesTemplates={this.drawGeometriesTemplates}
            drawLayerSideBySide={this.drawLayerSideBySide}
            drawPointsRouteFunction={this.drawPointsRouteFunction}
            drawRouteFunction={this.drawRouteFunction}
            drawToDownload={this.drawToDownload}
            gotoLocation={this.gotoLocation}
            goToCoordinatesFunction={this.goToCoordinatesFunction}
            mapCenter={mapCenter}
            mapbol={isMapMapLoaded}
            pointOfNotesMaps={this.pointOfNotesMaps}
            pointOfStreetView={this.pointOfStreetView}
          />
        )}

        <LeafletMap
          deployEnv={deployEnv}
          headerType="1"
          isAtlas={isAtlas}
          isFullScreen={isFullScreen}
          mapId={mapId}
          ref={this.mapMapComponent}
          updateMapState={this.updateMapState}
          {...this.props}
        />
        {!isPublicMap && showReloadPosition && (
          <ButtonOnMap numberOfButtonsRight={numberOfButtonsRight}>
            <div
              onClick={this.updateMapCenter}
              title="Reload initial map position"
              role="button"
              onKeyPress={() => ''}
              tabIndex={0}
            >
              <img
                src="/maps-buttons/flecha_ubicacion.svg"
                style={{ height: '34px', width: '34px', cursor: 'pointer' }}
                alt="Update Map Center"
              />
            </div>
          </ButtonOnMap>
        )}
      </>
    );
  }
}
MapContainerViewMap.defaultProps = {
  popupProp: false,
  externalBoton: false,
  isAtlas: false,
  isFullScreen: false,
  isPublicMap: false,
  updateLayerMapState: () => {},
  updateLocation: () => {},
  userControlSetting: {},
  handleMapLoaded: () => {},
  leafletMapId: 'mapMap',
  showReloadPosition: true
};

MapContainerViewMap.propTypes = {
  baseMaps: PropTypes.array.isRequired,
  deployEnv: PropTypes.string.isRequired,
  userControlSetting: PropTypes.object,
  externalBoton: PropTypes.bool,
  popupProp: PropTypes.bool,
  isAtlas: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  isPublicMap: PropTypes.bool,
  layers: PropTypes.array.isRequired,
  map: PropTypes.object.isRequired,
  updateLayerMapState: PropTypes.func,
  updateLocation: PropTypes.func,
  handleMapLoaded: PropTypes.func,
  leafletMapId: PropTypes.string,
  showReloadPosition: PropTypes.bool
};

export default MapContainerViewMap;
